/**
 * @file コンポーネント：検索キーワード絞り込み ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const SearchKeyword = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
